// I found the image from this link https://www.pexels.com/photo/man-wearing-blue-and-white-checked-sport-shirt-and-black-hat-1482101/
import React from "react";

function Blog() {
  return (
    <div className="bg-gray-100 dark:bg-gray-800 py-12">
      <div className=" space-y-4 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-8">
          Latest Articles
        </h2>
        <div className="overflow-hidden rounded-lg shadow-lg cursor-pointer">
          <a href="/" className="block w-full h-full">
            <img
              alt="A farmer wearing a straw hat"
              src="https://res.cloudinary.com/dxetyokin/image/upload/c_scale,f_auto,q_auto/v1676984967/Assigment%201/pexels-jake-heinemann-1482101_kminaj.jpg"
              className="object-cover w-full h-60 sm:h-80 md:h-64 lg:h-72"
            />
            <div className="p-4 bg-white dark:bg-gray-900">
              <p className="font-medium text-green-500 text-md">
                Sustainability
              </p>
              <p className="mb-2 text-xl font-medium text-gray-800 dark:text-white">
                Sustainable Farming Practices for a Better Future
              </p>
              <p className="font-light text-gray-600 dark:text-gray-400 text-md">
                Learn how sustainable farming practices can help us achieve a
                better future for the planet, the farmers, and the consumers.
              </p>
              <div className="flex flex-wrap items-center mt-4 justify-start">
                <div className="text-xs mr-2 py-1.5 px-4 text-gray-600 bg-green-100 rounded-2xl">
                  #Sustainability
                </div>
                <div className="text-xs mr-2 py-1.5 px-4 text-gray-600 bg-green-100 rounded-2xl">
                  #Farming
                </div>
              </div>
            </div>
          </a>
        </div>

        <div className="overflow-hidden rounded-lg shadow-lg cursor-pointer">
          <a href="/" className="block w-full h-full">
            <img
              alt="A farmer wearing a straw hat"
              src="https://res.cloudinary.com/dxetyokin/image/upload/c_scale,f_auto,q_auto/v1676984967/Assigment%201/pexels-jake-heinemann-1482101_kminaj.jpg"
              className="object-cover w-full h-60 sm:h-80 md:h-64 lg:h-72"
            />
            <div className="p-4 bg-white dark:bg-gray-900">
              <p className="font-medium text-green-500 text-md">
                Sustainability
              </p>
              <p className="mb-2 text-xl font-medium text-gray-800 dark:text-white">
                Sustainable Farming Practices for a Better Future
              </p>
              <p className="font-light text-gray-600 dark:text-gray-400 text-md">
                Learn how sustainable farming practices can help us achieve a
                better future for the planet, the farmers, and the consumers.
              </p>
              <div className="flex flex-wrap items-center mt-4 justify-start">
                <div className="text-xs mr-2 py-1.5 px-4 text-gray-600 bg-green-100 rounded-2xl">
                  #Sustainability
                </div>
                <div className="text-xs mr-2 py-1.5 px-4 text-gray-600 bg-green-100 rounded-2xl">
                  #Farming
                </div>
              </div>
            </div>
          </a>
        </div>

        <div className="overflow-hidden rounded-lg shadow-lg cursor-pointer">
          <a href="/" className="block w-full h-full">
            <img
              alt="A farmer wearing a straw hat"
              src="https://res.cloudinary.com/dxetyokin/image/upload/c_scale,f_auto,q_auto/v1676984967/Assigment%201/pexels-jake-heinemann-1482101_kminaj.jpg"
              className="object-cover w-full h-60 sm:h-80 md:h-64 lg:h-72"
            />
            <div className="p-4 bg-white dark:bg-gray-900">
              <p className="font-medium text-green-500 text-md">
                Sustainability
              </p>
              <p className="mb-2 text-xl font-medium text-gray-800 dark:text-white">
                Sustainable Farming Practices for a Better Future
              </p>
              <p className="font-light text-gray-600 dark:text-gray-400 text-md">
                Learn how sustainable farming practices can help us achieve a
                better future for the planet, the farmers, and the consumers.
              </p>
              <div className="flex flex-wrap items-center mt-4 justify-start">
                <div className="text-xs mr-2 py-1.5 px-4 text-gray-600 bg-green-100 rounded-2xl">
                  #Sustainability
                </div>
                <div className="text-xs mr-2 py-1.5 px-4 text-gray-600 bg-green-100 rounded-2xl">
                  #Farming
                </div>
              </div>
            </div>
          </a>
        </div>

        <div className="overflow-hidden rounded-lg shadow-lg cursor-pointer">
          <a href="/" className="block w-full h-full">
            <img
              alt="A farmer wearing a straw hat"
              src="https://res.cloudinary.com/dxetyokin/image/upload/c_scale,f_auto,q_auto/v1676984967/Assigment%201/pexels-jake-heinemann-1482101_kminaj.jpg"
              className="object-cover w-full h-60 sm:h-80 md:h-64 lg:h-72"
            />
            <div className="p-4 bg-white dark:bg-gray-900">
              <p className="font-medium text-green-500 text-md">
                Sustainability
              </p>
              <p className="mb-2 text-xl font-medium text-gray-800 dark:text-white">
                Sustainable Farming Practices for a Better Future
              </p>
              <p className="font-light text-gray-600 dark:text-gray-400 text-md">
                Learn how sustainable farming practices can help us achieve a
                better future for the planet, the farmers, and the consumers.
              </p>
              <div className="flex flex-wrap items-center mt-4 justify-start">
                <div className="text-xs mr-2 py-1.5 px-4 text-gray-600 bg-green-100 rounded-2xl">
                  #Sustainability
                </div>
                <div className="text-xs mr-2 py-1.5 px-4 text-gray-600 bg-green-100 rounded-2xl">
                  #Farming
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Blog;
